
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class PurchaseOrderService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.po_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_PO_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static initPurchaseOrderModule(input, responseCallBack, errorCallBack) {
    this.method(
      "initPurchaseOrderModule",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderPageList(input, responseCallBack, errorCallBack) {
    this.method(
      "getPurchaseOrderPageList",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method("updatePurchaseOrder", input, responseCallBack, errorCallBack);
  }
  static createPurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method("createPurchaseOrder", input, responseCallBack, errorCallBack);
  }
  static approvePurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method("approvePurchaseOrder", input, responseCallBack, errorCallBack);
  }
  static unApprovePurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "unApprovePurchaseOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static unLockPurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method("unLockPurchaseOrder", input, responseCallBack, errorCallBack);
  }
  static cancelPurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method("cancelPurchaseOrder", input, responseCallBack, errorCallBack);
  }
  static getSalesOrderDependentPurchaseOrdersDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSalesOrderDependentPurchaseOrdersDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseOrderLinesForMassMaintenance(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderLinesForMassMaintenance",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateExistringPurchaseOrderDate(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateExistringPurchaseOrderDate",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getOpenPurchaseOrderLinesForMassMaintenance(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getOpenPurchaseOrderLinesForMassMaintenance",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelMassPurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelMassPurchaseOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getPurchaseSourceSalesOrderLineDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseSourceSalesOrderLineDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getPurchaseOrderLinesDatasFromExcel(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getPurchaseOrderLinesDatasFromExcel",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static purchaseOrderInputExcelUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "purchaseOrderInputExcelUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updatePurchaseOrderAfterApproval(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updatePurchaseOrderAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fetchPurchaseOrderMailDefaultInfoBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "fetchPurchaseOrderMailDefaultInfoBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static sendPurchaseOrderMail(input, responseCallBack, errorCallBack) {
    this.method(
      "sendPurchaseOrderMail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApprovePurchaseOrderThenGeneratePurchaseOrderReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createAndApprovePurchaseOrderThenGeneratePurchaseOrderReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static readPurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method("readPurchaseOrder", input, responseCallBack, errorCallBack);
  }
  static getFabricStylePurchaseCost(input, responseCallBack, errorCallBack) {
    this.method(
      "getFabricStylePurchaseCost",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApprovePurchaseOrderThenGeneratePurchaseOrderReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateAndApprovePurchaseOrderThenGeneratePurchaseOrderReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createAndApprovePurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "createAndApprovePurchaseOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateAndApprovePurchaseOrder(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApprovePurchaseOrder",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelPurchaseOrderLine(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelPurchaseOrderLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static purchaseOrderImageUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "purchaseOrderImageUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static purchaseOrderDocUpload(input, responseCallBack, errorCallBack) {
    this.method(
      "purchaseOrderDocUpload",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.po_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" })
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.po_data_url,responseCallBack, errorCallBack);
    }
  }
}
